module.exports = __webpack_public_path__ + "prod/1.2.3/img/fail-close.d409cd27.svg";